import { MissionSummary } from '@edwin-group/cj-graphql';
import { useSpring, animated } from '@react-spring/web';
import { TraitHeader } from '../trait-header';
import { MissionFilter } from '../mission-filter';
import { Chart } from '../chart';
import { Table } from '../table';
import { useReportingToolsStore } from '@/pages/reporting-tools/store/useReportingToolsStore';

interface MissionSummaryItemProps {
  missionSummary: MissionSummary;
  traitExpanded: string | null;
  missionSelected: string | null;
  setTraitExpanded: (trait: string | null) => void;
  setMissionSelected: (mission: string | null) => void;
}

export const MissionSummaryItem = ({
  missionSummary,
  traitExpanded,
  missionSelected,
  setTraitExpanded,
  setMissionSelected,
}: MissionSummaryItemProps) => {
  const isExpanded = traitExpanded === missionSummary?.header?.trait;
  const page = useReportingToolsStore((state) => state.page);

  const expandAnimation = useSpring({
    maxHeight: isExpanded ? '1000px' : '0px',
    opacity: isExpanded ? 1 : 0,
    transform: isExpanded ? 'scaleY(1)' : 'scaleY(0)',
    config: { tension: 280, friction: 26 },
  });

  if (missionSummary?.header?.trait === 'RESPECT') {
    return null;
  }

  return (
    <div className="mb-sh-30 rounded-2xl border border-black p-8">
      <TraitHeader traitExpanded={traitExpanded} setTraitExpanded={setTraitExpanded} missionSummary={missionSummary} />

      <animated.div
        style={{
          ...expandAnimation,
          overflow: 'hidden',
          transformOrigin: 'top',
        }}>
        <div className="mt-sh-15 block">
          <h4 className=" text-sh-sm !font-semibold">{page?.missionSummary.assessmentProgress}</h4>
          <MissionFilter
            missionSummary={missionSummary}
            missionSelected={missionSelected}
            setMissionSelected={setMissionSelected}
          />
          <Chart missionSummary={missionSummary} missionSelected={missionSelected} />
          <Table missionSummary={missionSummary} />
        </div>
      </animated.div>
    </div>
  );
};
